/* unplugin-vue-components disabled */import { render } from "./LiangHao.vue?vue&type=template&id=4d3e0063"
import script from "./LiangHao.vue?vue&type=script&lang=js"
export * from "./LiangHao.vue?vue&type=script&lang=js"

import "./LiangHao.vue?vue&type=style&index=0&id=4d3e0063&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__